import React from 'react';
import { buttonVariants } from '@/components/ui/button-variants';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';
import {
  IconPlus,
  IconCircleDot,
  IconCheckbox,
  IconStar,
  IconForms,
} from '@tabler/icons-react';
import type { SurveyQuestionType } from '../../types';

interface QuestionTypeBarProps {
  onAddQuestion: (type: SurveyQuestionType) => void;
}

const questionTypes: Array<{ type: SurveyQuestionType; label: string; icon: React.ReactNode }> = [
  { type: 'radio', label: 'Single Choice', icon: <IconCircleDot className="size-4" /> },
  { type: 'checkbox', label: 'Multiple Choice', icon: <IconCheckbox className="size-4" /> },
  { type: 'rating', label: 'Rating', icon: <IconStar className="size-4" /> },
  { type: 'textfield', label: 'Text', icon: <IconForms className="size-4" /> },
];

export function QuestionTypeBar({ onAddQuestion }: QuestionTypeBarProps) {
  return (
    <div className="mb-2 cursor-pointer rounded border-2 border-dashed border-border p-2 text-center hover:border-primary hover:bg-muted/50">
      <DropdownMenu>
        <DropdownMenuTrigger
          className={cn(buttonVariants({ variant: 'ghost' }), 'gap-1')}
        >
          <IconPlus className="size-4" />
          <span>Add Question</span>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="center">
          {questionTypes.map(({ type, label, icon }) => (
            <DropdownMenuItem key={type} onClick={() => onAddQuestion(type)}>
              {icon}
              <span>{label}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
